import React from 'react'
import { motion } from 'framer-motion'
import { X } from 'lucide-react'

export default function CookiePolicy({ onClose }) {
  const fade = {
    hidden: { opacity: 0, y: 50 },
    visible: i => ({ opacity: 1, y: 0, transition: { delay: i * 0.04, duration: 0.55 } })
  }

  const sections = [
    {
      h: '1. คำนิยาม',
      p: [
        '“คุกกี้” (Cookie) คือ ไฟล์ข้อความขนาดเล็กที่ถูกจัดเก็บบนเบราว์เซอร์ เมื่อคุณเข้าชมเว็บไซต์',
        'เราใช้คุกกี้และเทคโนโลยีคล้ายกัน เช่น LocalStorage, Pixel, SDK (“คุกกี้”)',
      ],
    },
    {
      h: '2. ประเภทคุกกี้ที่ใช้',
      p: [
        'Strictly Necessary – จำเป็นต่อการทำงานของระบบ (Auth, CSRF, Load-balancer) **ฐานกฎหมาย:** สัญญา / ประโยชน์ชอบธรรม',
        'Functional – จดจำการตั้งค่า (ภาษา, ธีม) **ฐานกฎหมาย:** ยินยอม',
        'Analytics – วัดสถิติผู้เยี่ยมชมผ่าน Google Analytics 4 (IP Anonymization เปิด) **ฐานกฎหมาย:** ยินยอม',
        'Marketing – ปรับโฆษณาผ่าน Google Ads / Meta Pixel **ฐานกฎหมาย:** ยินยอม',
      ],
    },
    {
      h: '3. ระยะเวลาการจัดเก็บ',
      p: [
        'Session Cookie: หมดอายุเมื่อปิดเบราว์เซอร์',
        'Persistent Cookie: สูงสุด 13 เดือน (ตาม CNIL & PDPA แนวปฏิบัติ)',
      ],
    },
    {
      h: '4. การจัดการคุกกี้',
      p: [
        'ผู้ใช้สามารถให้/ถอน ความยินยอมได้ในแบนเนอร์ “การตั้งค่าคุกกี้” หรือที่เมนู Footer → Cookie Policy',
        'นอกจากนี้สามารถลบคุกกี้ผ่านเบราว์เซอร์ (Chrome, Safari, Firefox, Edge)',
      ],
    },
    {
      h: '5. การโอนข้อมูล & Sub-Processor',
      p: [
        'คุกกี้ Analytics และ Marketing อาจส่งข้อมูลไปยังสหรัฐฯ/สหภาพยุโรป เราใช้ Standard Contractual Clauses (SCCs) และเปิด IP Anonymization',
      ],
    },
    {
      h: '6. สิทธิของเจ้าของข้อมูล',
      p: [
        'ถอนความยินยอม​ได้ทุกเมื่อ (Art. 7 GDPR / PDPA ม.19)',
        'คัดค้านการประมวลผล (Art. 21 GDPR)',
        'ยื่นร้องเรียนต่อ สคส. (PDPA) หรือ Supervisory Authority (GDPR)',
      ],
    },
    {
      h: '7. การปรับปรุงนโยบายคุกกี้',
      p: [
        'เราจะอัปเดตฉบับล่าสุดในหน้านี้และแจ้งผู้ใช้ล่วงหน้า 7 วันหากมีการเปลี่ยนสาระสำคัญ',
      ],
    },
    {
      h: '8. ติดต่อ DPO',
      p: [
        'อีเมล: dpo@kuizy.ai  ·  โทร: +66 80-808-6001-5',
        'ที่อยู่: 21 ซอยประเสริฐมนูกิจ 29 แยก 7 ถนนประเสริฐมนูกิจ แขวงจรเข้บัว เขตลาดพร้าว กรุงเทพฯ 10230',
      ],
    },
  ]

  return (
    <section className="relative">
      <button
        onClick={onClose}
        className="fixed top-4 right-4 bg-white/80 backdrop-blur p-3 rounded-full shadow-lg hover:bg-white z-[60]"
      >
        <X size={30} />
      </button>

      <div className="pt-20 pb-10 px-6 max-w-5xl mx-auto space-y-12">
        <motion.h1
          className="text-4xl md:text-5xl font-extrabold text-primary text-center"
          variants={fade}
          custom={0}
          initial="hidden"
          animate="visible"
        >
          Cookie&nbsp;Policy
        </motion.h1>

        {sections.map((s, idx) => (
          <motion.div
            key={s.h}
            variants={fade}
            custom={idx + 1}
            initial="hidden"
            animate="visible"
            className="space-y-2"
          >
            <h2 className="text-xl md:text-2xl font-bold text-secondary">{s.h}</h2>
            {s.p.map((line, i) => (
              <p key={i} className="text-base md:text-lg leading-relaxed text-gray-700">{line}</p>
            ))}
          </motion.div>
        ))}
      </div>
    </section>
  )
}
